module.exports = __webpack_public_path__ + "img/cordoba.ecc844c6.jpg";